import api from "@/lib/api";

// If an API error is a participation gate (PMA membership or a required
// waiver), fetch and return the agreement to sign; otherwise return null.
export async function gateAgreementFromError(err) {
  const detail = err?.response?.data?.detail;
  if (detail && (detail.code === "pma_required" || detail.code === "agreement_required") && detail.agreement_id) {
    try {
      const { data } = await api.get(`/agreements/${detail.agreement_id}`);
      return data;
    } catch {
      return null;
    }
  }
  return null;
}
